<template>
    <div>
        <div class="top-contain">
            <div class='button-move'>
                <div class="top">
                    <el-button @click="scrollToImage('image1')"
                               round
                               class="custom-button">
                        <div style="padding-right:20px">
                            <span class="custom-span">Text & Voice</span>
                            <span class="custom-span">Translation</span>

                        </div>
                        <div><i class="el-icon-arrow-right custom-icon"></i>
                        </div>
                    </el-button>
                    <el-button @click="scrollToImage('image2')"
                               round
                               class="custom-button">
                        <div style="padding-right:20px">
                            <span class="custom-span">Photo</span> <span class="custom-span"> Translate</span>

                        </div>
                        <div><i class="el-icon-arrow-right custom-icon"></i>
                        </div>
                    </el-button>
                </div>

                <div class="middle">
                    <el-button @click="scrollToImage('image3')"
                               round
                               class="custom-button">
                        <div style="padding-right:20px"> <span class="custom-span">Real-time</span>
                            <span> Translate</span>
                        </div>
                        <div><i class="el-icon-arrow-right custom-icon"></i></div>
                    </el-button>
                    <el-button @click="scrollToImage('image4')"
                               round
                               class="custom-button">
                        <div style="padding-right:20px"> <span class="custom-span">Translate</span> <span>Keyboard</span>
                        </div>
                        <div><i class="el-icon-arrow-right custom-icon"></i>
                        </div>
                    </el-button>
                </div>
                <div class="last">
                    <el-button round
                               @click="navigateToTranslateForm"
                               class="last-button">
                        <div style="padding-right:20px">
                            Online
                            Translator
                        </div>
                        <div><i class="el-icon-arrow-right"></i>
                        </div>
                    </el-button>
                </div>
            </div>

        </div>
        <img ref="image1"
             class="img1"
             src="../img/2.png"
             alt="">
        <img ref="image2"
             class="img2"
             style="margin:5rem 0"
             src="../img/photo.png"
             alt="">
        <img ref="image3"
             class="img2"
             src="../img/real-time.png"
             alt="">
        <img ref="image4"
             class="img2"
             style="margin:5rem 0"
             src="../img/keyboard.png"
             alt="">
        <el-backtop target=".top-contain"
                    :visibility-height="1000"
                    :bottom="1000">
        </el-backtop>
    </div>

</template>

<script>
export default {
    methods: {
        scrollToImage(imageRef) {
            console.log('点击了', imageRef)
            const imageElement = this.$refs[imageRef]
            if (imageElement) {
                // 滚动页面到图片的位置
                imageElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                })
            }
        },
        navigateToTranslateForm() {
            this.$router.push({ name: 'TranslateForm', params: { id: '3' } })
        },
    },
}
</script>

<style>
@import url('../css/index.css');
</style>


// WEBPACK FOOTER //
// src/views/index.vue